// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--ff1fa";
export var carouselContainer = "styles-module--carouselContainer--96391";
export var container = "styles-module--container--c21fc";
export var title = "styles-module--title--ff174";